<template>
  <div>
    <p class="text-h5">Update</p>


  <p class="text-h6"><strong>You can view new, post-redistricting maps at our <a href="https://us.redistrictingandyou.org/" target="_blank">US version of Redistricting &amp; You</a>, where you can compare new district lines with pre-2020 Census lines</strong>.</p>

  <p class="text-body-1">The maps underneath this note reflect congressional &amp; state legislative districts <strong>before</strong> the 2021-2022 redistricting cycle.</p>
   
  </div>
</template>

<script>
export default {
  name: "ModalUpdate",
  components: {},
  data: function () {},
  watch: {},
  methods: {},
  computed: {},
};
</script>
<style scoped>
.social-links {
  padding: 10px 0;
  /* width: fit-content; */
  margin: 0 auto;
}
.social-links a {
  text-decoration: none;
}

.social-links .v-icon {
  border: 1px solid lightgrey;
  padding: 2px;
}
</style>